import { Badge } from '@/components/ui/badge';
import { Loader2, Check, AlertCircle, Clock } from 'lucide-react';
import type { LinkStatus } from '@readlater/shared';

interface StatusBadgeProps {
  status: LinkStatus;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  switch (status) {
    case 'pending':
      return (
        <Badge variant="secondary" className={className}>
          <Clock className="mr-1 h-3 w-3" />
          Pending
        </Badge>
      );
    case 'processing':
      return (
        <Badge variant="secondary" className={className}>
          <Loader2 className="mr-1 h-3 w-3 animate-spin" />
          Processing
        </Badge>
      );
    case 'processed':
      return (
        <Badge variant="default" className={className}>
          <Check className="mr-1 h-3 w-3" />
          Ready
        </Badge>
      );
    case 'failed':
      return (
        <Badge variant="destructive" className={className}>
          <AlertCircle className="mr-1 h-3 w-3" />
          Failed
        </Badge>
      );
    default:
      return null;
  }
}
